module.exports = __webpack_public_path__ + "static/media/steve-taylor-2.2e6bf02e.jpg";